function localeToLanguage(locale) {
    if (!locale) {
        return;
    }

    if (locale.length === 2) {
        return locale;
    }

    if (locale.includes('-')) {
        return locale.split('-')[0];
    }
}

function localeToCountry(locale) {
    if (!locale) {
        return;
    }

    if (locale.length === 2) {
        return null;
    }

    if (locale.includes('-')) {
        return locale.split('-')[1];
    }
}

function intlLocaleFromLocale(locale) {
    if (locale.indexOf('-') === -1) {
        return locale.toLowerCase();
    }

    const localeParts = locale.split('-');
    const language = localeParts[0].toLowerCase();
    const location = localeParts[1].toUpperCase();
    return `${language}-${location}`;
}

export {
    intlLocaleFromLocale,
    localeToCountry,
    localeToLanguage,
};

export default {
    localeToCountry,
    localeToLanguage,
    intlLocaleFromLocale,
};
